import classNames from "classnames";
import React from "react";

type ButtonProps = {
  btnType?: "primary" | "secondary";
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  customStyles?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
};

export const CustomButton: React.FC<ButtonProps> = ({
  children,
  onClick,
  customStyles,
  btnType = "primary",
  type = "button",
  disabled,
}) => {
  const buttonClass = classNames(
    "flex justify-center items-center gap-2 px-9 py-3 rounded-lg transition duration-150 ease-in-out transform",
    {
      "bg-[#3F51B5] text-white border-0 hover:bg-[#303F9F] active:scale-95 focus:outline-none focus:ring-2 focus:ring-[#303F9F]":
        btnType === "primary",
      "border-2 border-white text-white bg-transparent hover:bg-white hover:text-[#3F51B5] active:scale-95 focus:outline-none focus:ring-2 focus:ring-white":
        btnType === "secondary",
    },
    customStyles
  );

  return (
    <button
      className={buttonClass}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
